const typesFiles = {
  pdf: 'application/pdf',
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  csvFirefox: 'application/vnd.ms-excel',
  zip: 'application/zip',
  windowsZip: 'application/x-zip-compressed'
};

export { typesFiles };
